module.exports = __webpack_public_path__ + "img/pants.fb9331e7.png";